import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ManagePaymentMethodsRootParamList } from "../../../../types";
import React from "react";
import { useTranslation } from "../../../../utilities/i18n";
import {
  Badge,
  Button,
  FlatActionList,
  Page,
  PayTypeToIcon,
  Stack,
} from "@towersystems/roam-common-native";
import { useFocusEffect } from "@react-navigation/native";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";
import { Q } from "@nozbe/watermelondb";
import { View } from "react-native-ui-lib";
import spacingInstance from "react-native-ui-lib/src/style/spacings";
import { PayTypeDetailsText } from "../../components/PayTypeDetailsText";
import { CASH_PAY_TYPE_ID } from "../../../../constants";
import {
  CashRounding,
  RoundingAlgorithm,
} from "../../components/PaymentMethodForm/types";

export type ListPaymentMethodsScreenProps = NativeStackScreenProps<
  ManagePaymentMethodsRootParamList,
  "ListPaymentMethodsScreen"
>;

export const ListPaymentMethodsScreen = ({
  navigation,
}: ListPaymentMethodsScreenProps) => {
  const [paymentMethods, setPaymentMethods] = React.useState<PaymentMethod[]>(
    []
  );
  const { t } = useTranslation("settings");
  const database = useDatabase();

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () => {
        return (
          <Button
            label={t("button.create_payment_method")}
            isAction
            onPress={() =>
              navigation.navigate("CreatePaymentMethodRootScreen", {
                screen: "CreatePaymentMethodScreen",
              })
            }
            size="compact"
          ></Button>
        );
      },
    });
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      database
        .get<PaymentMethod>("payment_methods")
        .query(
          Q.on("pay_types", "internal", Q.eq(false)),
          Q.and(Q.where("deleted_at", Q.eq(null)))
        )
        .then((p) => {
          setPaymentMethods(p);
        });
      return () => {};
    }, [])
  );

  return (
    <Page
      title="Payment methods"
      secondaryTitle="Create, edit and manage payment methods"
    >
      <FlatActionList
        items={paymentMethods.map((p) => {
          return {
            key: p.id,
            title: p.name,
            titleContent: ({ title }) => {
              return (
                <View row centerV>
                  <View style={{ paddingRight: spacingInstance.s4 }}>
                    <PayTypeToIcon payType={p.payType.id} />
                  </View>
                  <Stack spacing={1} vertical>
                    <Stack centerVertical>
                      {title}
                      {p.enabled == false ? (
                        <Badge enabledStatus="DISABLED" />
                      ) : undefined}
                    </Stack>
                    <PayTypeDetailsText payType={p.payType} />
                  </Stack>
                </View>
              );
            },
            onPress: () => {
              let d: any = {};

              if (p.handler?.code === "cash") {
                d.rounding = {
                  cashRounding:
                    p.handler?.args?.find((a) => a.name === "cashRounding")
                      ?.value ?? CashRounding.ROUND_TO_05,
                  roundingAlgorithm:
                    p.handler?.args?.find((a) => a.name === "roundingAlgorithm")
                      ?.value ?? RoundingAlgorithm.ROUND_MIDPOINT_DOWN,
                };
              }

              console.log("Payment method handler args:", p.handler, d);

              // this should just be passing the payment method id...
              navigation.navigate("CreatePaymentMethodRootScreen", {
                screen: "CreatePaymentMethodScreen",
                defaultFormData: {
                  id: p.id,
                  name: p.name,
                  payTypeId: p.payType.id,
                  enabled: p.enabled,
                  retailerPayTypeId: p.retailerPayTypeId ?? undefined,
                  ...d,
                },
              });
            },
          };
        })}
      />
    </Page>
  );
};
